/* eslint-disable */ module.exports = {
  localeData: {
    plurals: function (n, ord) {
      if (ord) return 'other';
      return n == 1 ? 'one' : 'other';
    },
  },
  messages: {
    '#Contenido': '#Contenido',
    '#Curso': '#Curso',
    '#ID Anterior': '#ID Anterior',
    '#Instancia': '#Instancia',
    '#Perfil': '#Perfil',
    '#Perfil Spac': '#Perfil Spac',
    '#Profile Spac': '#Perfil SPAC',
    '#ProfileSpac': '#Perfil SPAC',
    '#Turno': '#Turno',
    '- Curso sin contenidos -': '- Curso sin contenidos -',
    '<0>Est\xE1 por empezar el test {0}</0>':
      '<0>Est\xE1 por empezar el test {0}</0>',
    'Abandonar curso': 'Abandonar curso',
    Accept: 'Aceptar',
    Acciones: 'Acciones',
    Activado: 'Activado',
    Actividad: 'Actividad',
    Activo: 'Activo',
    'Activo en': 'Activo en',
    Actualizacion: 'Actualizaci\xF3n',
    'Actualizado por': 'Actualizado por',
    Add: 'Agregar',
    AdminHSE: 'AdminHSE',
    AdminITPS: 'AdminITPS',
    AdminQA: 'AdminQA',
    Administrador: 'Administrador',
    Agregar: 'Agregar',
    'Agregar Asistentes': 'Agregar Asistentes',
    'Agregar requerimientos a cursos': 'Agregar requerimientos a cursos',
    'Agregar respuesta': 'Agregar respuesta',
    Anterior: 'Anterior',
    Aprobado: 'Aprobado',
    Aprobados: 'Aprobados',
    'Aprobados (%)': 'Aprobados (%)',
    'Aprob\xF3': 'Aprob\xF3',
    'Arrastre el PDF ac\xE1 o haga click para seleccionarlos.':
      'Arrastre el PDF ac\xE1 o haga click para seleccionarlos.',
    'Aseg.Calidad': 'Aseg. calidad',
    Asistentes: 'Asistentes',
    'Asistentes (%)': 'Asistentes (%)',
    'Asistentes seleccionados': 'Asistentes seleccionados',
    'Asisti\xF3': 'Asisti\xF3',
    Attended: 'Cursada',
    'Attended does not exist': 'Cursada no existe',
    Attendeds: 'Cursadas',
    'A\xF1adir material': 'A\xF1adir material',
    'BP Propietario': 'BP Propietario',
    Baja: 'Baja',
    Bienvenido: 'Bienvenido ',
    CWID: 'CWID',
    Calificacion: 'Calificaci\xF3n',
    'Calificaci\xF3n': 'Calificaci\xF3n',
    Calificado: 'Calificado',
    Cancel: 'Cancelar',
    Cancelada: 'Cancelada',
    Cancelar: 'Cancelar',
    'Cantidad total': 'Cantidad total',
    'Capa inicial': 'Capa inicial',
    'Capa inicial leg': 'Capa inicial leg',
    'Capacitaciones de todos los colaboradores':
      'Capacitaciones de todos los colaboradores',
    'Capacitación Colaboradores': 'Capacitación Colaboradores',
    'Capacitaciones pendientes por SPAC': 'Capacitaciones pendientes por SPAC',
    'Capacitaciones pendientes por sector':
      'Capacitaciones pendientes por sector',
    'Capacitaciones pendientes por spac': 'Capacitaciones pendientes por spac',
    'Capacitations Pending by SPAC': 'Capacitaciones pendientes por SPAC',
    'Capacitations for collaborators': 'Capacitaciones por colaboradores',
    'Capacitations pending by sector': 'Capacitaciones pendientes por sector',
    'Cargando...': 'Loading...',
    'Cargar nuevo PDF': 'Cargar nuevo PDF',
    Categoria: 'Categoria',
    'Categoria de hardware': 'Categor\xEDa de hardware',
    'Categoria de software': 'Categor\xEDa de software',
    'Cerrar sesi\xF3n': 'Cerrar sesi\xF3n',
    Choice: 'Pregunta',
    'Clonar curso': 'Clonar curso',
    Colaborador: 'Colaborador',
    'Colaborador responsable': 'Colaborador responsable',
    Colaboradores: 'Colaboradores',
    'Colaboradores por capacitacion': 'Colaboradores por capacitaci\xF3n',
    Collaborator: 'Colaborador',
    Collaborators: 'Colaboradores',
    'Compa\xF1\xEDa': 'Compa\xF1\xEDa',
    Completed: 'Completado',
    Condicion: 'Condicion',
    'Condicion colaborador': 'Condicion colaborador',
    'Configuracion de los parametros Generales':
      'Configuraci\xF3n de los par\xE1metros generales',
    'Confirm operation': 'Confirmar operaci\xF3n',
    'Confirmaci\xF3n del curso': 'Confirmaci\xF3n del curso',
    Confirmar: 'Confirmar',
    'Confirmar credenciales': 'Confirmar credenciales',
    'Confirmar operaci\xF3n': 'Confirmar operaci\xF3n',
    Consult: 'Consultas',
    'Consulta por mes': 'Consulta por mes',
    'Consulta por sector': 'Consulta por sector',
    'Consulta por usuario': 'Consulta por usuario',
    Consultas: 'Consultas',
    Contenido: 'Contenido',
    Contenidos: 'Contenidos',
    'Contrase\xF1a': 'Contrase\xF1a',
    'Copiar perfil': 'Copiar perfil',
    Course: 'Curso',
    'Course types': 'Tipos de cursos',
    'Course Types': 'Tipos de cursos',
    'CourseType does not exist': 'Tipo de cursos no existe',
    Courses: 'Cursos',
    'Creado correctamente': 'Creado correctamente',
    Crear: 'Crear',
    'Crear curso': 'Crear curso',
    'Crear reporte': 'Crear reporte',
    'Cuestionario N\xB0': 'Cuestionario N\xB0',
    'Cuestionario aprobado exitosamente': 'Cuestionario aprobado exitosamente',
    'Cuestionario desaprobado': 'Cuestionario desaprobado',
    Curso: 'Curso',
    'Curso clonado exitosamente': 'Curso clonado exitosamente',
    'Curso creado correctamente': 'Curso creado correctamente',
    'Curso de capacitaci\xF3n': 'Curso de capacitaci\xF3n',
    'Curso modificado correctamente': 'Curso modificado correctamente',
    'Curso terminado con puntaje': 'Curso terminado con puntaje',
    Curso_: 'Curso_',
    Cursos: 'Cursos',
    'Delete row': 'Eliminar fila',
    Desactivado: 'Desactivado',
    Desarrollo: 'Desarrollo',
    'Descargar PDF': 'Descargar PDF',
    'Descargar excel': 'Descargar excel',
    Descripcion: 'Descripci\xF3n',
    'Descripci\xF3n': 'Descripci\xF3n',
    'Deseleccionar todos': 'Deseleccionar todos',
    'Detalle de SPACS': 'Detalle de SPACS',
    'Detalle de la instancia': 'Detalle de la instancia',
    'Detalle de la instancia:': 'Detalle de la instancia:',
    'Detalle del SPAC:': 'Detalle del SPAC:',
    'Detalle del colaborador': 'Detalle del colaborador',
    'Detalle del colaborador:': 'Detalle del colaborador:',
    'Detalle del sector': 'Detalle del sector',
    'Detalle del sector:': 'Detalle del sector:',
    Documento: 'Documento',
    'Documento/Código': 'Documento/Código',
    Dominio: 'Dominio',
    'Due\xF1o del sistema': 'Due\xF1o del sistema',
    Duracion: 'Duraci\xF3n',
    'Duraci\xF3n': 'Duraci\xF3n',
    'ERROR: El perfil no existe.': 'ERROR: El perfil no existe.',
    'ERROR: Ya existe un perfil-colaborador con este perfil y colaborador':
      'ERROR: Ya existe un perfil-colaborador con este perfil y colaborador',
    'Planta Alberti': 'Planta Alberti',
    'Planta Santa Cruz': 'Planta Santa Cruz',
    'Planta Pagola': 'Planta Pagola',
    'Planta Pilar': 'Planta Pilar',
    Edit: 'Editar',
    'Editando curso': 'Editando curso',
    Editar: 'Editar',
    'Editar requerimientos': 'Editar requerimientos',
    Editing: 'En edici\xF3n',
    'El CWID ingresado ya se encuentra en uso':
      'El CWID ingresado ya se encuentra en uso',
    'El archivo solicitado no existe': 'El archivo solicitado no existe',
    'El nuevo puntaje obetenido sobreescribrir\xE1 el \xFAltimo obtenido':
      'El nuevo puntaje obetenido sobreescribrir\xE1 el \xFAltimo obtenido',
    'El nuevo puntaje sobreescribrir\xE1 el \xFAltimo obtenido':
      'El nuevo puntaje sobreescribrir\xE1 el \xFAltimo obtenido',
    Eliminado: 'Eliminado',
    Empezada: 'Empezada',
    'En Progreso': 'En Progreso',
    'En Edicion': 'En edici\xF3n',
    'En edicion': 'En edici\xF3n',
    'En ejecucion': 'En ejecucion',
    'En licencia': 'En licencia',
    'En progreso': 'En progreso',
    'En tiempo': 'En tiempo',
    'Error al procesar la solicitud': 'Error al procesar la solicitud',
    'Espa\xF1ol': 'Espa\xF1ol',
    Estado: 'Estado',
    'Estado del curso': 'Estado del curso',
    'Este campo es obligatorio': 'Este campo es obligatorio',
    'Este colaborador no se encuentra activo o registrado en la base de datos':
      'Este colaborador no se encuentra activo o registrado en la base de datos',
    'Est\xE1 a punto de clonar el curso': 'Est\xE1 a punto de clonar el curso',
    'Est\xE1 por empezar el test {0}': 'Est\xE1 por empezar el test {0}',
    'Experto Materia': 'Experto Materia',
    'Expiraci\xF3n': 'Expiraci\xF3n',
    'Expiration:': 'Expiraci\xF3n:',
    Falta: 'Falta ',
    'Falta de tiempo debido a volumen de trabajo':
      'Falta de tiempo debido a volumen de trabajo',
    Fecha: 'Fecha',
    'Fecha de Actualizacion': 'Fecha de actualizaci\xF3n',
    'Fecha de actualizacion': 'Fecha de actualizaci\xF3n',
    'Fecha de Requerimiento': 'Fecha de Requerimiento',
    'Fecha de Vigencia': 'Fecha de vigencia',
    'Fecha de expiraci\xF3n': 'Fecha de expiraci\xF3n',
    'Fecha de ingreso': 'Fecha de ingreso',
    'Fecha de instancia': 'Fecha de instancia',
    'Fecha de realizacion': 'Fecha de realizaci\xF3n',
    'Fecha de vigencia': 'Fecha de vigencia',
    'Fecha fin': 'Fecha fin',
    'Fecha final': 'Fecha final',
    'Fecha inicial': 'Fecha inicial',
    'Fecha inicio': 'Fecha inicio',
    'Finalizaci\xF3n': 'Finalizaci\xF3n',
    'Finalizaci\xF3n de curso': 'Finalizaci\xF3n de curso',
    Finalizada: 'Finalizada',
    Finalizar: 'Finalizar',
    'Finalizar edici\xF3n': 'Finalizar edici\xF3n',
    Finished: 'Finalizado',
    Firma: 'Firma',
    Firmar: 'Firmar',
    'Fomulario XMLS': 'Fomulario XMLS',
    Generar: 'Generar',
    'Generar requerimiento': 'Generar requerimiento',
    Gerencia: 'Gerencia',
    'Gestion de capacitaciones': 'Gesti\xF3n de capacitaciones',
    Grupo: 'Grupo',
    'Grupo HSE': 'Grupo HSE',
    'Grupo ITPS': 'Grupo ITPS',
    'Grupo QA': 'Grupo QA',
    'Grupo capacitador': 'Grupo capacitador',
    'Grupo colaborador': 'Grupo colaborador',
    Hay: 'Hay',
    Horario: 'Horario',
    Cochabamba: 'Cochabamba',
    'Casa Central': 'Casa Central',
    'ID Instancia': 'ID Instancia',
    'Imprimir examen': 'Imprimir examen',
    'Imprimir reporte': 'Imprimir asistentes',
    'In progress': 'En progreso',
    InPerson: 'Papel',
    InProgress: 'En Progreso',
    Inactivo: 'Inactivo',
    'Informaci\xF3n del curso': 'Informaci\xF3n del curso',
    'Ingl\xE9s': 'Ingl\xE9s',
    'Ingrese sus credenciales para firmar su asistencia':
      'Ingrese sus credenciales para firmar su asistencia',
    'Ingrese sus credenciales para confirmar la operaci\xF3n':
      'Ingrese sus credenciales para confirmar la operaci\xF3n',
    'Ingrese un email v\xE1lido': 'Ingrese un email v\xE1lido',
    'Ingrese un n\xFAmero correcto': 'Ingrese un n\xFAmero correcto',
    'Ingrese una fecha correcta': 'Ingrese una fecha correcta',
    Iniciar: 'Iniciar',
    'Iniciar sesi\xF3n': 'Iniciar sesion',
    Inicio: 'Inicio',
    Inscripto: 'Inscripto',
    Instance: 'Instancia',
    'Instance management': 'Gesti\xF3n de instancias',
    Instances: 'Instancias',
    'Instances by Sectors': 'Instancias por sector',
    'Instances by sectors': 'Instancias por sector',
    'Instances by spac': 'Instancias por spac',
    Instancia: 'Instancia',
    Instancias: 'Instancias',
    'Instancias por capacitacion': 'Instancias por capacitaci\xF3n',
    Instructor: 'Instructor',
    Instructors: 'Instructores',
    Intento: 'Intento',
    'Invalid Date Format': '"Fecha incorrecta',
    'Ir a la tabla choice': 'Ir a la tabla choice',
    'Ir al detalle': 'Ir al detalle',
    'La fecha de vigencia debe ser igual o mayor a la fecha actual':
      'La fecha de vigencia debe ser igual o mayor a la fecha actual',
    Legajo: 'Legajo',
    'Licencia M\xE9dica': 'Licencia M\xE9dica',
    'Marque con un \u2714\uFE0F las respuestas correctas':
      'Marque con un \u2714\uFE0F las respuestas correctas',
    Material: 'Material',
    Materiales: 'Materiales',
    'Mi Tablero': 'Mi tablero',
    'Mi tablero': 'Mi tablero',
    'Módulo Reporting': 'Módulo Reporting',
    Modalidad: 'Modalidad',
    'Modalidad:': 'Modalidad:',
    Modality: 'Modalidad',
    'Modo de encriptacion': 'Modo de encriptaci\xF3n',
    Motivo: 'Motivo',
    Multiple: 'Multiple',
    'M\xFAltiple': 'M\xFAltiple',
    No: 'No',
    'No Empezada': 'No Empezada',
    'No aplica': 'No aplica',
    'No hay notificaciones.': 'No hay notificaciones.',
    'No se encontraron cursos correspondientes para ese perfil':
      'No se encontraron cursos correspondientes para ese perfil',
    'No se encuentra realizado en tiempo':
      'No se encuentra realizado en tiempo',
    'No se ha podido autenticar al usuario correctamente - intente nuevamente m\xE1s tarde':
      'No se ha podido autenticar al usuario correctamente - intente nuevamente m\xE1s tarde',
    'No se puede finalizar un curso no aprobado':
      'No se puede finalizar un curso no aprobado',
    'No se puede loguear el usuario': 'No se puede loguear el usuario',
    Nombre: 'Nombre',
    'Nombre Curso': 'Nombre Curso',
    'Nombre del Curso': 'Nombre del Curso',
    'Nombre del PDF': 'Nombre del PDF',
    'Nombre del SPAC': 'Nombre del SPAC',
    'Nombre del Spac': 'Nombre del Spac',
    'Nombre del asistente': 'Nombre del asistente',
    'Nombre del curso': 'Nombre del curso',
    'Nombre del empleado': 'Nombre del empleado',
    'Numero de empleado': 'Numero de empleado',
    'Nombre del perfil': 'Nombre del perfil',
    'Nombre del sector': 'Nombre del sector',
    'Nombre sector': 'Nombre sector',
    'Not yet started': 'Sin empezar',
    'Notificaciones via email': 'Notificaciones v\xEDa email',
    'Habilitar notificaciones por email': 'Habilitar notificaciones por email',
    'Nro. de empleado responsable': 'Nro. de empleado responsable',
    Observacion: 'Observaci\xF3n',
    Obsolete: 'Obsoleto',
    Obsoleto: 'Obsoleto',
    Online: 'Online',
    'Política de contraseñas': 'Política de contraseñas',
    'Operacion terminada exitosamente': 'Operaci\xF3n terminada exitosamente',
    Otros: 'Otros',
    Papel: 'Papel',
    'Para acceder a la documentaci\xF3n externa, pulse el siguiente enlace:':
      'Para acceder a la documentaci\xF3n externa, pulse el siguiente enlace:',
    Parametros: 'Par\xE1metros',
    Password: 'Contrase\xF1a',
    Pendiente: 'Pendiente',
    Perfil: 'Perfil',
    'Perfil SPAC': 'Perfil SPAC',
    'Perfil Spac': 'Perfil SPAC',
    'Perfil-Colaborador': 'Perfil-Colaborador',
    'Perfil-Curso': 'Perfil-Curso',
    'Perfil-Spac': 'Perfil-SPAC',
    Perfiles: 'Perfiles',
    'Perfiles Seleccionados': 'Perfiles seleccionados',
    Pictograma: 'PEPPPP',
    Planta: 'Planta',
    'Please enter your credentials to confirm operation':
      'Ingrese sus credenciales para confirmar la operaci\xF3n',
    'Please provide a password': 'Por favor, ingrese una contrase\xF1a',
    'Poco tiempo entre creaci\xF3n del curso y vigencia del SOP':
      'Poco tiempo entre creaci\xF3n del curso y vigencia del SOP',
    'Por favor seleccione m\xE1ximo 25 sectores.':
      'Por favor seleccione m\xE1ximo 25 sectores.',
    Porcentaje: 'Porcentaje',
    Pregunta: 'Pregunta',
    Presente: 'Presente',
    Procentaje: 'Procentaje',
    Produccion: 'Producci\xF3n',
    Profile: 'Perfil',
    'Recomendado para el puerto 465 (SSL implícito).':
      'Recomendado para el puerto 465 (SSL implícito).',
    'Recomendado para el puerto 587. Requerido por la mayoría de los servidores modernos.':
      'Recomendado para el puerto 587. Requerido por la mayoría de los servidores modernos.',
    'Requerir Número': 'Requerir Número',
    'Requerir Símbolo': 'Requerir Símbolo',
    'Bloquear secuencias obvias': 'Bloquear secuencias obvias',
    'Bloquear datos personales': 'Bloquear datos personales',
    'Longitud mínima': 'Longitud mínima',
    'Evitar reutilización de contraseñas':
      'Evitar reutilización de contraseñas',
    Responsable: 'Responsable',
    'Profile General Spac': 'Profile General Spac',
    'Profile Spac': 'Perfil SPAC',
    'Profile collaborator': 'Perfil-colaborador',
    'Profile does not exist': 'El perfil no existe',
    'Profile-Collaborator': 'Perfil-Colaborador',
    'Profile-Course': 'Perfil-Curso',
    'Profile-General': 'Perfil-General',
    Profiles: 'Perfiles',
    Propietario: 'Propietario',
    'Proveedor de sistemas': 'Proveedor de sistemas',
    Puerto: 'Puerto',
    Puntaje: 'Puntaje',
    'Puntaje m\xEDnimo': 'Puntaje m\xEDnimo',
    'Puntaje necesario': 'Puntaje necesario',
    'Raz\xF3n tardanza': 'Raz\xF3n tardanza',
    ReValidado: 'ReValidado',
    Reason: 'Motivo',
    'Registro de firma': 'Registro de firma',
    Reporte: 'Reporte',
    'Reporte - capacitaci\xF3n inicial': 'Reporte - capacitaci\xF3n inicial',
    'Reporte de integritdad de datos': 'Reporte de integridad de datos',
    Requerimientos: 'Requerimientos',
    Requirement: 'Requerimiento',
    'Requirement does not exist': 'Requerimientos no existe',
    Requirements: 'Requerimientos',
    Respuesta: 'Respuesta',
    Revision: 'Revisi\xF3n',
    Role: 'Rol',
    'Ruta de materiales': 'Ruta de materiales',
    'Ruta del registro de firma': 'Ruta del registro de firma',
    Rutas: 'Rutas',
    'SALIR DEL MODO TABLET': 'SALIR DEL MODO TABLET',
    SPAC: 'SPAC',
    Salir: 'Salir',
    'Salir de modo tablet': 'Salir de modo tablet',
    'Se encuentra realizado en tiempo': 'Se encuentra realizado en tiempo',
    'Se encuentra vencido': 'Se encuentra vencido',
    'Se guardar\xE1 el intento con puntaje 0.':
      'Se guardar\xE1 el intento con puntaje 0.',
    Sector: 'Sector',
    Sectores: 'Sectores',
    'Seleccionar Perfiles': 'Seleccionar perfiles',
    'Seleccionar m\xEDnimo una respuesta correcta.':
      'Seleccionar m\xEDnimo una respuesta correcta.',
    'Seleccionar todos': 'Seleccionar todos',
    'Server de LDAP': 'Server de LDAP',
    'Servicio de IT': 'Servicio de IT',
    Si: 'Si',
    Siguiente: 'Siguiente',
    Simple: 'Simple',
    'Sin Empezar': 'Sin Empezar',
    'Sin empezar': 'Sin empezar',
    Spac: 'Spac',
    Stage: 'Instancia',
    Stages: 'Instancias',
    'Tabla de integrity': 'Tabla de integrity',
    Tablet: 'Tablet',
    Terminado: 'Terminado',
    'Tiempo de expiraci\xF3n de capacitaciones iniciales (en d\xEDas)':
      'Tiempo de expiraci\xF3n de capacitaciones iniciales (en d\xEDas)',
    Time: 'Tiempo',
    Tipo: 'Tipo',
    'Tipo de curso': 'Tipo de curso',
    'Tipo de encriptacion': 'Tipo de encriptaci\xF3n',
    Todos: 'Todos',
    'Tomar curso': 'Tomar curso',
    Trainer: 'Capacitador',
    Turn: 'Turno',
    Turno: 'Turno',
    Turnos: 'Turnos',
    Turns: 'Turnos',
    'T\xEDtulo': 'T\xEDtulo',
    'URL en el email': 'URL en el email',
    'Ultima contrase\xF1a': '\xDAltima contrase\xF1a',
    'Ultimo inicio de sesion': '\xDAltimo inicio de sesion',
    'Una vez finalizado el curso ya no se podr\xE1 editar y se crear\xE1n las instancias online.':
      'Una vez finalizado el curso ya no se podr\xE1 editar y se crear\xE1n las instancias online.',
    User: 'Usuario',
    Users: 'Usuarios',
    'Modo anónimo': 'Modo anónimo',
    'Usar modo anónimo': 'Usar modo anónimo',
    'Usar STARTTLS': 'Usar STARTTLS',
    'Usar SSL': 'Usar SSL',
    'Usted tiene': 'Usted tiene',
    'Usted tiene {0} curso/s que estan por vencer':
      'Usted tiene {0} curso/s que estan por vencer',
    'Usted tiene {value} curso/s que estan por vencer':
      'Usted tiene {value} curso/s que estan por vencer',
    Usuario: 'Usuario',
    'SMTP Usuario': 'SMTP Usuario',
    'SMTP Contraseña': 'SMTP Contraseña',
    'Puerto SMTP': 'Puerto SMTP',
    'Servidor SMTP': 'Servidor SMTP',
    'Dirección remitente (From)': 'Dirección remitente (From)',
    'Se recomienda activar STARTTLS cuando se usa autenticación SMTP.':
      'Se recomienda activar STARTTLS cuando se usa autenticación SMTP.',
    'Usuario y/o contrase\xF1a incorrectos':
      'Usuario y/o contrase\xF1a incorrectos',
    Vacaciones: 'Vacaciones',
    Valid: 'Vigente',
    Validado: 'Validado',
    'Validar dominio': 'Validar dominio',
    'Validar grupo': 'Validar grupo',
    Valido: 'V\xE1lido',
    'Vence el:': 'Vence el:',
    'Vence el: ': 'Vence el: ',
    'Vence en': 'Vence en',
    'Vence hoy': 'Vence hoy',
    'Vence ma\xF1ana': 'Vence ma\xF1ana',
    Vencido: 'Vencido',
    'Vencimiento de la instancia': 'Vencimiento de la instancia',
    'Vencimiento:': 'Vencimiento:',
    Ver: 'Ver',
    'Ver todos': 'Ver todos',
    'Versi\xF3n': 'Versi\xF3n',
    'Versi\xF3n tablet': 'Versi\xF3n tablet',
    Vigente: 'Vigente',
    Visualizar: 'Visualizar',
    Volver: 'Volver',
    'Cambiar fecha de expiración': 'Cambiar fecha de expiración',
    'Volver a realizar cuestionario': 'Volver a realizar cuestionario',
    'Volver al material': 'Volver al material',
    '_Asistencia.pdf': '_Asistencia.pdf',
    '_CapacitacionInicial.pdf': '_CapacitacionInicial.pdf',
    '_Test.pdf': '_Examen.pdf',
    '_reporte.pdf': '_Reporte.pdf',
    'al curso': 'al curso',
    almostDueDate: '> 1 y \u2264 7 d\xEDas',
    'capacitaciones pendientes para': 'capacitaciones pendientes para',
    'collaborator does not exist': 'Ese colaborador no existe',
    'content does not exist': 'contenido no existe',
    'course does not exist': 'Ese curso no existe',
    'curso/s que estan por vencer': 'curso/s que est\xE1n por vencer',
    'curso/s que estan por vencer o ya est\xE1n vencidos':
      'curso/s que estan por vencer o ya est\xE1n vencidos',
    'cursos por vencer.': 'cursos por vencer.',
    'dia/s para que venza': ' d\xEDa/s para que expire',
    dued: '\u2264 0 d\xEDas (VENCIDAS)',
    'd\xEDas': 'd\xEDas',
    'editado correctamente': 'Editado correctamente',
    finished: 'Finalizado',
    finishedDued: 'Finalizado vencido',
    finishedOnTime: 'Finalizado en tiempo',
    nearDueDate: '> 7 y \u2264 15 d\xEDas',
    onTime: '> 15 d\xEDas',
    pending: 'Pendiente',
    'sector does not exist': 'Ese sector no existe',
    'ultimo login': '\xDAltimo login',
    'values is empty': 'Los datos ingresados estan vac\xEDos',
    'values null': 'No se enviaron datos',
    '{0}': '{0}',
    '\xBFDesea finalizar la instancia? Una vez aceptado la instancia estara finalizada y no se podra seguir editando':
      '\xBFDesea finalizar la instancia? Una vez aceptado, la instancia pasar\xE1 a finalizada y no se podr\xE1 seguir editando',
    '\xBFDesea volver a realizarlo?': '\xBFDesea volver a realizarlo?',
    '\xBFDesesa volver a realizarlo?': '\xBFDeseas volver a realizarlo?',
    '\xBFEst\xE1 seguro que desea salir del curso?':
      '\xBFEst\xE1 seguro que desea salir del curso?',
    '\xDAltimo puntaje aprobado exitosamente':
      '\xDAltimo puntaje aprobado exitosamente',
    '\xDAltimo puntaje obtenido:': '\xDAltimo puntaje obtenido:',
  },
};
